<template>
  <div style="overflow-y: hidden; overflow-x: scroll" class="full-width">
    <div v-if="!inPreviewMode" class="row no-wrap justify-left">
      <!-- all charts have this -->
      <MostaSelect
        v-model="widthModel"
        :options="widthOptions"
        style="min-width: 180px; margin-top: 6px; margin-left: 5px; margin-right: 5px;"
      />
      <MostaSelect
        v-show="scaleLinear"
        v-model="elementWidthModel"
        :options="elementWidthOptions"
        style="min-width: 180px; margin-top: 6px; margin-left: 5px; margin-right: 5px;"
      />

      <button
        v-if="genstore.selectedItem && genstore.selectedItem.Id"
        type="button"
        class="qt-panel-icon-btn"
        @click="onRefreshClick"
        :aria-label="$t('refresh_label')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53683 17.3559C7.08197 17.0665 5.7456 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.07091 7.12987C3.63856 5.75943 4.59986 4.58809 5.83323 3.76398C7.0666 2.93987 8.51664 2.5 10 2.5C12.1 2.5 14.1083 3.33333 15.6167 4.78333L17.5 6.66667" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 2.5V6.66667H13.3333" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300">{{ $t('refresh_label') }}</q-tooltip>
      </button>
      <button v-if="!querystore.isLoading"
        type="button"
        class="qt-panel-icon-btn"
        @click="saveChartToFile"
        :aria-label="$t('load')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 12.5V2.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.83331 8.33337L9.99998 12.5L14.1666 8.33337" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300">{{ $t('load') }}</q-tooltip>
      </button>
      <button v-if="genstore.selectedItem"
        type="button"
        class="qt-panel-icon-btn"
        @click="copyLinkToItem"
        :aria-label="$t('copy_link')"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5 6C15.3284 6 16 5.32843 16 4.5C16 3.67157 15.3284 3 14.5 3C13.6716 3 13 3.67157 13 4.5C13 5.32843 13.6716 6 14.5 6Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.5 11C6.32843 11 7 10.3284 7 9.5C7 8.67157 6.32843 8 5.5 8C4.67157 8 4 8.67157 4 9.5C4 10.3284 4.67157 11 5.5 11Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.15833 11.2583L12.85 14.575" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12.8417 5.42505L7.15833 8.74172" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <q-tooltip :delay="300">{{ $t('copy_link') }}</q-tooltip>
      </button>

      <div class="q-mt-md" style="font-weight: normal;" 
        v-if="modelValue && modelValue.LastForceRecalculatedAt">&nbsp;({{ $t('current_at') }}&nbsp;{{ lastCalcDate }})
      </div>
    </div>
    <div v-if="querystore.isLoading" style="text-align: center; margin-top: 100px; width: 100%;">
      <q-spinner-dots
        color="primary"
        size="2em"
      />
    </div>
    <div v-else-if="displaying" :style="'width: '+((inPreviewMode ? 1 : widthMultiplier)*100)+'%; display: flex; flex-flow: column;'">
      <div style="display: block;">

        <!-- :style="`width: ${(index === option.length-1) && ((index+1) % 2 !== 0) || 
          (theModel as AnalyticsPieChartBundleResult).DisplayType === 1 ? '90%' : '49%'
        }; height: ${(index === option.length-1) && ((index+1) % 2 !== 0) || 
          (theModel as AnalyticsPieChartBundleResult).DisplayType === 1 ? '78vh' : '44vh'
        }; ${!inPreviewMode ? 'float: left;' : 'margin: 0 auto;'}`" -->
        
        <!-- `width: ${(index === option.length-1) && ((index+1) % 2 !== 0) || 
          (theModel as AnalyticsPieChartBundleResult).DisplayType === 1 ? (49/widthMultiplier)+'%' : (49/widthMultiplier)+'%'
        };  -->

        <div>
          <div v-for="(opt, index) in option" :key="'chart_'+index" 
            :style="`height: ${theModel.ChartType === 0 ? (!scaleLinear ? '80vh' : Math.floor(70*elementWidthMultiplierDraw)+'vh') : ((index === option.length-1) && ((index+1) % 2 !== 0) || 
              (theModel as AnalyticsPieChartBundleResult).DisplayType === 1 ? Math.floor(chart_height*elementWidthMultiplierDraw) : Math.floor(chart_height*elementWidthMultiplierDraw))+'px'
            }; ${!inPreviewMode ? 'float: left; margin: 30px;' : 'margin: 0 auto;'} width: ${theModel.ChartType === 0 ? (!scaleLinear ? '95%' : Math.floor(95*elementWidthMultiplierDraw)+'%') : Math.floor(chart_width*elementWidthMultiplierDraw)+'px'};`">

            <div class="text-h6">{{ opt.title.custom_text }}</div>
            <div class="text-h8 text-blue cursor-pointer" style="text-decoration: underline;"
            @click="onRepeatingClick($event, index, opt.repeating)">{{ opt.title.custom_subtext }}</div>

            <v-chart style="margin-top: 5px;" :option="opt" :init-options="{ width: 'auto', height: 'auto' }" 
              @click="onChartClick($event, index)" @finished="onChartRendered" autoresize ref="chart"
            />
          </div>
        </div>
        <div v-if="currentTokens && currentTokens.length"
        style="display: inline-block; width: 100%; margin-top: 22px !important; background-color: white; padding: 10px; border: 1px solid #e0e0e0; border-radius: 4px;">
          <div class="full-width text-h6" style="border-bottom: 1px solid #e0e0e0; padding: 5px;">{{ sectorName }}:</div>
          <formula-selector
            v-show="currentTokens && currentTokens.length"
            :input-parameter-options="graphstore.getCurrentFormulas"
            :input-index="0"
            nested-key-name="ChildFormulas" template-name="Entity"
            :formula-options="[]"
            :global-formulas-mode="true"
            is-incorrect=""
            :read-only="true"
            v-model="currentTokens"
          />
        </div>
      </div>
      <!-- <q-dialog maximized v-model="showSectorTable" fit> -->
      <div style="width: 100%; min-height: 100vh;" class="q-my-lg">
        <q-card v-show="showSectorTable">
          <q-card-section class="row items-center">
            <div class="text-h6">{{ sectorName || $t('chart_sector_report') }}</div>
            <q-space />
            <q-btn icon="close" flat round dense v-close-popup @click="showSectorTable = false" />
          </q-card-section>
      
          <q-separator />
          <!-- без .scroll: секция не должна быть своим скролл-контейнером, иначе она
               перехватывает колесо над таблицей. Таблица сектора в page-режиме своей
               прокрутки не имеет, вертикаль уходит на скролл всей страницы, а горизонталь
               широкой таблицы обеспечивает корневой контейнер графика (overflow-x: scroll). -->
          <q-card-section style="display: flex;">
            <!-- Скелетон только на первой загрузке сектора (данных ещё нет). При
                 сортировке/листании модель не обнуляется, шапка остаётся, а лоадер
                 даёт сама таблица через refresh-strip - как в главной таблице. -->
            <div
              v-if="auxstore.isTableLoading && !(sectorTableModel && (sectorTableModel as AnalyticsResultTableExtended).HeaderRow)"
              style="width: 100%; flex: 1 1 0; min-height: 0;"
            >
              <QTLiteSkeleton />
            </div>

            <query-table class="full-width"
              v-show="sectorTableModel && 
              (sectorTableModel as AnalyticsResultTableExtended).HeaderRow"
              :src-element="genstore.selectedItem"
              :is-sector="true" :sector-entity-ids="entity_ids"
              :paginationModel="pagination"
              @update:paginationModel="onUpdatePagination"
              :selectedEverything="selectedAll"
              @update:selectedEverything="onSelectedAllUpdate"
              :selectedEntities="selectedEntities"
              @update:selectedEntities="onSelectionUpdate"
              :unselectedEntities="unselectedEntities"
              @update:unselectedEntities="onUnSelectionUpdate"
              @movePage="onMovePage"
              @refreshPage="onRefreshPage"
              v-model="sectorTableModel" />
          </q-card-section>
        </q-card>
      </div>
      <!-- </q-dialog> -->
    </div>
  </div>
</template>
  
<script lang="ts">
  import { Component, Prop, Vue, Emit, Watch, Setup } from 'vue-facing-decorator';
  import VChart from 'vue-echarts';
  import { use } from 'echarts/core';
  import { CanvasRenderer } from 'echarts/renderers';
  import { PieChart, LineChart, BarChart } from 'echarts/charts';
  import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
    TimelineComponent,
    DataZoomComponent,
    DataZoomInsideComponent
  } from 'echarts/components';
  import { trimEllip } from '@/models/helpers/recursive';
  import { AnalyticsBarChartBundleResult, AnalyticsChartElementWithFormulasResult, AnalyticsChartFormulaResult, 
    AnalyticsChartIdentity, AnalyticsChartResultBase, AnalyticsChartSectorGroupResult, AnalyticsLinearChartCurveResult, 
    AnalyticsLinearChartResult, AnalyticsPieChartBundleResult, ChartElementFormulaErrorResultType, 
    ChartElementFormulaTokenError, ChartSettingsBase, ChartUniqueSplitType, 
    LinearChartSettingsBase} from '@/models/interfaces/entity-settings/charts/charts';
  import { AnalyticsChartSectorCalculateStatus, AnalyticsFormulaTokenDescriptor, 
    AnalyticsLinearChartCurveCalculateStatus, AnalyticsOrderingType, AnalyticsV2ChartType, PieChartBundleDisplayType } from '@/models/etc/types';
  import QueryTable from '../querytable/QueryTable.vue';
  import QTLiteSkeleton from '../querytable/refactored/QTLiteSkeleton.vue';
  import { AnalyticsChartSectorTableAsker, AnalyticsChartSectorTableOrdering, AnalyticsWorkloadChartSectorTableAsker, AnalyticsWorkloadChartTableAskerBase, AnalyticsWorkloadCurvePointTableAsker, auxStore } from '@/store/auxillary';
  import { AnalyticsResultTableExtended } from '@/models/interfaces/entity-settings/querytable/querytable';
  import { reactive } from 'vue';
  import { PaginationProps } from '@/models/base/common.selector';
  import { queryStore } from '@/store/querytable';
  // import { storeToRefs } from 'pinia';
  import { graphSettingsStore } from '@/store/graph';
  import moment from 'moment';
  import { generalStore } from '@/store/general';
  import FormulaSelector from '../formula-selector/FormulaSelector.vue';
  import MostaSelect from '@/components/common/MostaSelect.vue';
  import { AnalyticsFormulaToken } from '@/models/interfaces/entity-settings/parameters/parameters';
  import { date } from 'quasar';
  import { useQuasar } from 'quasar';
import { AnalyticsWorkloadChartSectorGroupResult, AnalyticsWorkloadChartSectorResult, AnalyticsWorkloadLinearChartCurveResult } from '@/models/interfaces/entity-settings/charts/workload-charts';
import _ from 'lodash';
import echarts from 'echarts/types/dist/echarts';
import { buildClientUrl } from '@/utils/urlHelpers';

  var gen = require('color-generator');
  const SCALE_LINEAR = process.env.VUE_APP_SCALE_LINEAR
  
  use([
    CanvasRenderer,
    PieChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    LineChart,
    BarChart,
    ToolboxComponent,
    TimelineComponent,
    DataZoomComponent,
    DataZoomInsideComponent
  ]);

  @Component({
    name: 'QueryChart',
    components: {
      VChart, QueryTable, FormulaSelector, MostaSelect, QTLiteSkeleton
    }
  })
  export default class QueryChart extends Vue {
    @Prop({ default: undefined })
    modelValue?: AnalyticsChartResultBase
    @Prop({ default: undefined })
    srcElement?: AnalyticsChartIdentity
    @Prop({ default: false })
    inPreviewMode?: boolean

    @Emit("update:modelValue") emitModelValue(arg: any | undefined ) { return arg; }
    @Emit("refreshChart") emitRefreshChart(arg: any | undefined ) { return arg; }

    pagination: PaginationProps = reactive({} as PaginationProps);
    selectedEntities: number[] = reactive([])
    unselectedEntities: number[] = reactive([])
    selectedAll: string = ''

    querystore: any = undefined
    graphstore: any = undefined
    // graphstore: any = undefined

    // table
    option: any[] = []
    showSectorTable: boolean = false
    sectorTableModel: any = reactive({} as AnalyticsResultTableExtended)
    auxstore: any = undefined
    genstore: any = undefined
    // auxstore: any
    sectorName: string = ''

    // fill in before calling pie/bar chart sector table
    entity_ids: number[] = reactive([])
    worker_ids: number[] = reactive([])
    currentChartId: number = 0;
    currentTokens: AnalyticsFormulaToken[] = reactive([])
    // fill in before calling workload chart linear curve point sector table
    linear_params: {
      CurveId: number;
      StartDate: Date;
      EndDate: Date; } | undefined = undefined;

    isWorkload: boolean = false;
    colors = new Map();

    // chart size calcuation
    long_text_threshold: number = 25;
    base_chart_width: number = 450;
    base_chart_height: number = 200;

    base_bar_chart_width: number = 240;
    base_bar_chart_height: number = 250;

    chart_width: number = this.base_chart_width;
    chart_height: number = this.base_chart_height
    chart_multiplier: number = 1

    elementWidthMultiplierDraw = 0;
    displaying = true;

    data_volume_size: Map<number, number> = new Map();
    // longest_line: Map<number, number> = new Map();

    @Setup((props, ctx) => {
      const $q = useQuasar()
      return {
        showNotification (msg: string) {
          $q.notify({
            color: 'white',
            textColor: 'grey-8',
            icon: undefined,
            message: msg,
            position: 'top',
            timeout: 1000
          })
        }
      }
    })
    data: any

    created() {
      this.selectedEntities = reactive([])
      this.unselectedEntities = reactive([])
      this.sectorTableModel = reactive({} as AnalyticsResultTableExtended);
      this.resetPagination

      this.querystore = queryStore();
      this.auxstore = auxStore();
      this.genstore = generalStore();
      this.graphstore = graphSettingsStore();

      // this.graphstore = storeToRefs(this.graphstore)
      // this.auxstore = storeToRefs(this.auxstore)
    }

    async copyUrl(l: string) {
      const el = document.createElement('textarea');
      el.value = l;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const sel = document.getSelection();
      const selected = sel && sel.rangeCount > 0 ? sel.getRangeAt(0) : false;
      el.select();
      
      document.execCommand('copy');
      this.data.showNotification(this.$t('link_to_item')+' "'+this.genstore.selectedItem.Name+'" '+this.$t('copied_to_clipboard'))

      document.body.removeChild(el);
      if (sel && selected) {
        sel.removeAllRanges();
        sel.addRange(selected);
      }
    }

    onRefreshClick() {
      this.emitRefreshChart(undefined)
    }

    copyLinkToItem() {
      if (this.genstore.selectedItem.Id) {
        console.log('copy link '+this.genstore.selectedItem.Id)
        // setTimeout(() => {
        const l = buildClientUrl('analyticsvue?type='+
        this.genstore.selectedItem.elType+'&src=' + (this.genstore.selectedItem.SrcType === undefined ? '' : this.genstore.selectedItem.SrcType) +
          '&dest='+this.genstore.selectedItem.DestType+'&id='+this.genstore.selectedItem.Id)

        console.log(l)
        this.copyUrl(l)
      }
    }

    get lastCalcDate() {
      if (!this.modelValue || !this.modelValue.LastForceRecalculatedAt) { return '' }
      return date.formatDate(this.modelValue?.LastForceRecalculatedAt, 'DD.MM.YY HH:mm')
    }

    get widthMultiplier() {
      if (!this.widthModel) { return 1 }
      return this.widthModel.multiplier
    }

    get elementWidthMultiplier() {
      if (!this.elementWidthModel) {
        if (!this.elementWidthMultiplierDraw) { this.elementWidthMultiplierDraw = 1 }
        return 1
      }
      if (!this.elementWidthMultiplierDraw) { this.elementWidthMultiplierDraw = this.elementWidthModel.multiplier }
      return this.elementWidthModel.multiplier
    }

    // width function
    get widthOptions() {
      // multiplier to 100% = (value + 1) - value*0.5
      return [{
        label: this.$t('quarter_screen_width'),
        value: 5,
        multiplier: 0.25
      }, {
        label: this.$t('half_screen_width'),
        value: 6,
        multiplier: 0.5
      }, {
        label: this.$t('screen_0_75'),
        value: 7,
        multiplier: 0.75
      }, {
        label: this.$t('screen_width'),
        value: 0,
        multiplier: 1
      }, {
        label: this.$t('screen_1_25'),
        value: 8,
        multiplier: 1.25
      }, {
        label: this.$t('screenup_width'),
        value: 1,
        multiplier: 1.5
      }, {
        label: this.$t('screen_1_75'),
        value: 9,
        multiplier: 1.75
      }, {
        label: this.$t('double_screen_width'),
        value: 2,
        multiplier: 2
      }, {
        label: this.$t('doubleup_screen_width'),
        value: 3,
        multiplier: 2.5
      }, {
        label: this.$t('triple_screen_width'),
        value: 4,
        multiplier: 3
      }]
    }

    // TODO - Translase
    // width function
    get elementWidthOptions() {
      // multiplier to base size
      return [{
        label: 'x0.25',
        value: 7,
        multiplier: 0.25
      }, {
        label: 'x0.5',
        value: 1,
        multiplier: 0.5
      }, {
        label: 'x0.75',
        value: 2,
        multiplier: 0.75
      }, {
        label: 'x1',
        value: 0,
        multiplier: 1
      }, {
        label: 'x1.25',
        value: 3, // 4 - 1.25
        multiplier: 1.25
      }, {
        label: 'x1.5',
        value: 4,
        multiplier: 1.5
      }, {
        label: 'x1.75',
        value: 5,
        multiplier: 1.75
      }, {
        label: 'x2',
        value: 6,
        multiplier: 2
      }]
    }

    get scaleLinear(): boolean {
      return (SCALE_LINEAR == 1)
    }

    set widthModel(val: any) {
      if (!this.graphstore || !this.theModel || !(this.theModel as ChartSettingsBase)) { return }
      
      this.graphstore && ((this.graphstore.getCurrentSettings as ChartSettingsBase).ChartWidth = val.value)
    }

    get widthModel(): any {
      if (!this.graphstore) { return 0 }
      return this.widthOptions.find(opt => opt.value === (this.graphstore.getCurrentSettings as ChartSettingsBase)?.ChartWidth)
    }

    set elementWidthModel(val: any) {
      if (!this.graphstore || !(this.graphstore.getCurrentSettings as ChartSettingsBase)) { return }
      this.graphstore && ((this.graphstore.getCurrentSettings as ChartSettingsBase).ChartElementWidth = val.value)
    }

    get elementWidthModel(): any {
      if (!this.graphstore || !(this.graphstore.getCurrentSettings as ChartSettingsBase)) { return 0 }
      return this.elementWidthOptions.find(opt => opt.value === (this.graphstore.getCurrentSettings as ChartSettingsBase)?.ChartElementWidth)
    }

    get stepType(): any {
      if (!this.graphstore) { return 0 }
      return (this.graphstore.getCurrentSettings.value as LinearChartSettingsBase)?.StepType
    }

    getSectorCalculateStatusName(arg: number): string {
      switch (arg) {
        case AnalyticsChartSectorCalculateStatus.AddressLevelInvalid:
          return this.$t('address_incorrect');
          case AnalyticsChartSectorCalculateStatus.AnalyzedElementInvalid:
          return this.$t('selection_incorrect');
          case AnalyticsChartSectorCalculateStatus.BordersForNumberParameterInvalid:
          return this.$t('parameter_borders_incorrect');
          case AnalyticsChartSectorCalculateStatus.EmptyAnalyzedElementResult:
          return this.$t('selection_empty');
          case AnalyticsChartSectorCalculateStatus.SplittingParameterInvalid:
          return this.$t('split_incorrect');
          case AnalyticsChartSectorCalculateStatus.WorkerRolesInvalid:
          return this.$t('roles_incorrect');
        case AnalyticsChartSectorCalculateStatus.Ok:
        default:
          return ''; //'Расчёт в порядке';
      }
    }

    getCurveCalculateStatusName(arg: number): string {
      switch (arg) {
        case AnalyticsLinearChartCurveCalculateStatus.AnalyzedElementInvalid:
          return this.$t('selection_incorrect');
        case AnalyticsLinearChartCurveCalculateStatus.EvaluationParameterInvalid:
          return this.$t('parameter_incorrect');
        case AnalyticsLinearChartCurveCalculateStatus.EmptyAnalyzedElementResult:
          return this.$t('selection_empty');
        case AnalyticsLinearChartCurveCalculateStatus.Ok:
        default:
          return ''; //'Расчёт в порядке';
      }
    }

    onUpdatePagination(arg: any) {
      this.pagination = arg
    }

    onSelectionUpdate(val: any) {
      this.selectedEntities = val
    }

    onUnSelectionUpdate(val: any) {
      this.unselectedEntities = val
    }

    onSelectedAllUpdate(val: any) {
      this.selectedAll = val
    }

    resetPagination() {
      this.pagination = reactive({
        count: Number(this.auxstore.getTableRowCount),
        offset: 0,
        recalculate: false,
        sortMode: 0,
        OrderByPinned: false,
        sortCategory: 0,
        OrderingEntityIds: [],
        report: false,
        total_count: 0,
        report_index: -1,
      })
    }

    @Watch('elementWidthMultiplier')
    redraw_watcher(val: boolean, old_val: boolean) {
      if (val !== undefined && old_val !== undefined && val !== old_val) {
        this.redraw();
      }
    }

    // Отслеживаем изменения option
    @Watch('option')
    async onChartRendered(val: any, old_val: any) {
      if (!_.isEqual(val, old_val)) {
        await this.$nextTick()
        this.elementWidthMultiplierDraw = this.elementWidthMultiplier;
      }
    }

    @Watch('querystore.isLoading')
    mounted() {
      const that = this;
      setTimeout(() => {
        that.redraw()
      }, 100)
    }

    redraw() {
      this.$nextTick(() => {
        const str = this.$t('repeating_label')
        setTimeout(() => {
          if (this.querystore.isLoading || !this.theModel || 
            (!(this.theModel as any).CurveResults &&
            !(this.theModel as any).BarChartResults &&
            !(this.theModel as any).PieChartResults)) { return }

            if (this.theModel.ChartType === AnalyticsV2ChartType.Linear) {
              // this.data_volume_size = new Map();
              // this.data_volume_size.set(0, (this.theModel as AnalyticsLinearChartResult).CurveResults.length);
              // this.longest_line = new Map();
            
              // (this.theModel as AnalyticsLinearChartResult).CurveResults.forEach((curve) => {
              //   this.longest_line.set(0, (curve as AnalyticsLinearChartCurveResult).Name.length);
              // });

              if ((this.theModel as AnalyticsLinearChartResult).CurveResults.length && 
              (this.theModel as AnalyticsLinearChartResult).CurveResults[0].Descriptor === 4) {
                this.isWorkload = true;
              } else {
                this.isWorkload = false;
              }

              let legend_type = 'scroll'
              let legend_orient = 'vertical'
              let bars_width = Math.round(80*
              (this.elementWidthMultiplier >= 1 ? (this.elementWidthMultiplier < 1.5 ? 0.94 : 1) : Math.sqrt(this.elementWidthMultiplier)))+'%';
              this.chart_width = this.base_bar_chart_width + this.base_bar_chart_height
              this.chart_height = this.base_bar_chart_height
              let legend_width = this.chart_height
              let legend_align = 'right'
              let chart_font_size = 12;

              // any lines, very large data
              legend_type = 'scroll'

              // console.log('bw: '+bars_width)

              const real_koeff = Math.pow(this.elementWidthMultiplier, 0.3)
              this.chart_multiplier = 1;
              this.chart_height = this.base_bar_chart_height*(this.chart_multiplier/real_koeff)

              this.chart_width = this.base_bar_chart_width*this.chart_multiplier + this.base_bar_chart_height
              legend_width = this.chart_height

              chart_font_size = chart_font_size*real_koeff

              this.option = [{
                title: {
                  text: '', // (this.theModel as any).CurveResults.map((el: any) => el.Name).join(', '),
                  subtext: '' // (this.theModel as any).CurveResults
                  //.filter((els: any) => els.CalculateStatus > 0)
                  // .map((el: any) => this.getCurveCalculateStatusName(el.CalculateStatus)).join(', ')
                },
                animation: false,
                tooltip: {
                  trigger: 'item',
                  formatter: this.stepType === 5 && this.isWorkload ? function (params: any) {
                    var date = new Date(params.value[0]);
                    return '<b>'+params.seriesName+'</b> '+date.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })+': '+params.value[1]
                  } : function (params: any) {
                    var date = new Date(params.value[0]);
                    return '<b>'+params.seriesName+'</b> '+date.toLocaleDateString(undefined, { dateStyle: 'short' })+': '+params.value[1]
                  }
                },
                xAxis: {
                  type: 'time',
                  min: (new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[0].StartDate)).toISOString(), 
                  // max: '2023-12-31' // если нужно ограничить и конец
                  minInterval: 24*3600*1000,
                  splitLine: {
                    show: false
                  },
                  boundaryGap: false,
                  axisLine: {
                    onZero: false
                  }, // Fix the bug
                  axisLabel: {
                    showMinLabel: true, // Принудительно показать первую метку
                    showMaxLabel: true,  // Принудительно показать последнюю метку
                    formatter: function (value: any, index: any) {
                        const date = new Date(value);
                        const d = date.getDate().toString().padStart(2, '0');
                        const m = (date.getMonth() + 1).toString().padStart(2, '0');
                        const y = date.getFullYear();
                        return `${d}.${m}.${y}`; // Вернет "01.05.2023"
                    }
                  },
                  axisTick: {
                    show: true,
                    alignWithLabel: false, // Для времени лучше выключить, чтобы не прыгало
                  }
                },
                yAxis: {
                  alignTicks: false,
                  // maxInterval: 1,
                  type: 'value',
                  boundaryGap: false,
                  splitLine: {
                    show: false
                  },
                },
                grid: {
                    containLabel: true,
                    width: bars_width,
                    height: '80%',
                    top: '3%',
                    left: 0,
                  },
                  legend: {
                    data: (this.theModel as any).CurveResults.map((el: any) => el.Name),
                    type: legend_type,
                    orient: legend_orient,
                    align: legend_align,
                    height: '95%',
                    right: 0,
                    top: 0,
                    width: 'auto', // legend_width,
                    borderWidth: 0,
                    borderRadius: 1,
                    icon: 'roundRect',
                    padding: 0,
                    itemGap: 7,
                    textStyle: {
                     // width: Math.floor(this.chart_width*(this.elementWidthMultiplier > 0.5 ? 2*this.elementWidthMultiplier : this.elementWidthMultiplier)*
                       // (100-bars_width)/100),
                      overflow: "break",
                      fontSize: chart_font_size*0.8,
                      padding: 0
                    }
                  },
                  textStyle: {
                    fontSize: chart_font_size,
                  },
                dataZoom: [
                  {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100,
                    filterMode: 'none'
                  }, {
                    type: 'slider',
                    realtime: true,
                    start: 0,
                    end: 100,
                    filterMode: 'none',
                    labelFormatter:
                      function(params: any) {
                        var date = new Date(params);
                        return (
                          /*date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) +
                          '.' +
                          (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }) +
                          '.' +
                          date.getFullYear() */
                          date.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })
                        );
                      }
                  }
                ],
                // toolbox: {
                //   right: 10,
                //   feature: {
                //     dataZoom: {
                //       yAxisIndex: 'none'
                //     },
                //     restore: {},
                //     saveAsImage: {}
                //   }
                // },
                series: (this.theModel as AnalyticsLinearChartResult).CurveResults.map(curve => {
                    return {
                      name: (curve as AnalyticsLinearChartCurveResult).Name,
                      data: (curve.Descriptor === 1 || curve.Descriptor === 4) ? (curve as AnalyticsLinearChartCurveResult).PointResults?.map((el, day) => {
                        return [
                          /*moment((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].includes('-') ? 
                            (this.theModel as AnalyticsLinearChartResult).XAxisValues[day].split(' - ')[1] :*/
                            new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].EndDate).toISOString(),
                          el.Value,
                          curve.Descriptor,
                          (curve as AnalyticsLinearChartCurveResult).Name
                        ]
                      }) : (curve as AnalyticsChartElementWithFormulasResult).FormulaResults?.map((el, day) => {
                        if (day < (this.theModel as AnalyticsLinearChartResult).XAxisValues.length) {
                          // error or not
                          return el.Value == null ? {
                              value: [/*moment((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].includes('-') ? 
                              (this.theModel as AnalyticsLinearChartResult).XAxisValues[day].split(' - ')[1] : */
                              new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].EndDate).toISOString(),
                              el.Value || 0, curve.Descriptor,
                              (curve as AnalyticsLinearChartCurveResult).Name],
                              // item style, only works in this data item.
                              itemStyle: {
                                color: 'grey'
                              },
                              symbolSize: 8
                            } : [
                            /*moment((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].includes('-') ? 
                              (this.theModel as AnalyticsLinearChartResult).XAxisValues[day].split(' - ')[1] : */
                              new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[day].EndDate).toISOString(),
                            el.Value,
                            curve.Descriptor,
                            (curve as AnalyticsLinearChartCurveResult).Name
                          ]
                        } else {
                          const lastdate = /* moment((this.theModel as AnalyticsLinearChartResult).XAxisValues[(this.theModel as AnalyticsLinearChartResult).XAxisValues.length-1].includes('-') ? 
                              (this.theModel as AnalyticsLinearChartResult).XAxisValues[(this.theModel as AnalyticsLinearChartResult).XAxisValues.length-1].split(' - ')[1] : */
                              (this.theModel as AnalyticsLinearChartResult).XAxisValues[(this.theModel as AnalyticsLinearChartResult).XAxisValues.length-1].EndDate;

                          const newdate = new Date(lastdate)
                          newdate.setDate(newdate.getDate() + day)
                          // error or not
                          return el.Value == null ? {
                              value: [newdate.toISOString(), el.Value, curve.Descriptor,
                              (curve as AnalyticsLinearChartCurveResult).Name],
                              // item style, only works in this data item.
                              itemStyle: {
                                color: 'grey'
                              },
                              symbolSize: 8
                            } : [
                            newdate.toISOString(),
                            el.Value,
                            curve.Descriptor,
                            (curve as AnalyticsLinearChartCurveResult).Name
                          ]
                        }
                      }),
                      type: 'line',
                      smooth: true,
                      symbol: 'circle',
                      showSymbol: true,
                      symbolSize: curve.Descriptor === 3 ? 6 : ((this.theModel as AnalyticsLinearChartResult).XAxisValues.length > 200 ? 3 : 
                      ((this.theModel as AnalyticsLinearChartResult).XAxisValues.length > 70 ? 4 : ((this.theModel as AnalyticsLinearChartResult).XAxisValues.length > 20 ? 5 : 6))),
                      showAllSymbol: curve.Descriptor === 3,
                      itemStyle: {
                        normal: {
                          color: (curve as AnalyticsLinearChartCurveResult).Color
                        }
                      },
                      lineStyle: {
                        color: (curve as AnalyticsLinearChartCurveResult).Color,
                        width: 1.4
                      },
                    }
                  })
              }]

              // console.log('linear option: ');
              // console.log(this.option.length);
            } else if (this.theModel.ChartType === AnalyticsV2ChartType.Pie) {

              // generate random colors
              // const colors = new Map();
              // this.data_volume_size = new Map();
              // this.longest_line = new Map();
              this.isWorkload = false;
            
              (this.theModel as AnalyticsPieChartBundleResult).PieChartResults.forEach((pie, pie_index) => {
                // this.data_volume_size.set(pie_index, (pie as AnalyticsChartSectorGroupResult).SectorResults ? 
                // (pie as AnalyticsChartSectorGroupResult).SectorResults.length : 0);
                // this.longest_line.set(pie_index, 0);

                (pie as AnalyticsChartSectorGroupResult).SectorResults?.forEach(el => {
                  // if (this.longest_line.get(pie_index) || 0 < el.Name.length) {
                  //   this.longest_line.set(pie_index, el.Name.length);
                  // }

                  if (pie.Descriptor === 5) {
                    this.isWorkload = true;
                  }

                  const split_ident = (pie.Descriptor === 2 || pie.Descriptor === 5) ? 
                    ''+(el.Id.EntityId === ChartUniqueSplitType.Parameter ? el.Id.ParameterId+':'+el.Id.EntityId : el.Id.EntityId)+'-'+el.Id.SplittingType :
                    el.Id;
                  if (((pie.Descriptor === 2 || pie.Descriptor === 5) ? el.Id.EntityId : el.Id) != 0 && !this.colors.get(split_ident)) {
                    const new_color = gen().hexString();
                    this.colors.set(split_ident, new_color)
                  }
                })
              });
              
              this.option = (this.theModel as AnalyticsPieChartBundleResult).PieChartResults.map((pie, pie_index) => {
                let legend_type = 'scroll'
                let legend_orient = 'vertical'
                let legend_height: any = '100%';
                let legend_top = 0;

                this.chart_width = this.base_chart_width + this.base_bar_chart_height
                this.chart_height = this.base_chart_height
                let legend_align = 'right'
                let chart_font_size = 12;

                let bars_mult = this.elementWidthMultiplier < 1 ? Math.pow(this.elementWidthMultiplier, 0.7) : Math.pow(this.elementWidthMultiplier, 0.3)

                // any lines, very large data
                legend_type = 'scroll'

                const real_koeff = Math.pow(this.elementWidthMultiplier, 0.2)
                const base_width_add = this.base_bar_chart_height
                this.chart_multiplier = 1.4;
                this.chart_height = this.base_chart_height*(this.chart_multiplier/real_koeff)

                let bars_width = Math.round((this.base_bar_chart_width*bars_mult/(this.base_bar_chart_width + base_width_add))*100);
                this.chart_width = this.base_bar_chart_width*this.chart_multiplier*(this.elementWidthMultiplier >= 1 ? (this.elementWidthMultiplier >= 1.5 ? 0.4 : 0.6) : 1.1/Math.sqrt(this.elementWidthMultiplier)) + base_width_add

                chart_font_size = chart_font_size*real_koeff-1

                if (this.elementWidthMultiplier > 0.5) {
                  bars_width = bars_width*1.5
                }

                let chart_x = (bars_width/3+5)*(this.elementWidthMultiplier >= 1 ? (this.elementWidthMultiplier >= 1.5 ? 1.2 : 1.4) : 1.4/Math.sqrt(this.elementWidthMultiplier))+'%'
                let chart_y = '50%'
                let chart_r1 = '5%'
                let chart_r2 = bars_width*(this.elementWidthMultiplier >= 1 ? (this.elementWidthMultiplier >= 1.5 ? 0.8 : 1) : 1.1/Math.sqrt(this.elementWidthMultiplier))+'%'

                return {
                  // custom
                  repeating: (pie as AnalyticsChartSectorGroupResult).RepeatingEntityIds || [],
                  // standard
                  title: {
                    // standard
                    text: '',
                    subtext: '',
                    // custom
                    custom_text: (pie as AnalyticsChartSectorGroupResult).Name,
                    custom_subtext: this.getSectorCalculateStatusName((pie as AnalyticsChartSectorGroupResult).CalculateStatus) + 
                    ((pie as AnalyticsChartSectorGroupResult).CalculateStatus != null && (pie as AnalyticsChartSectorGroupResult).CalculateStatus != AnalyticsChartSectorCalculateStatus.Ok ? ', ' : '') +
                    str+' ' + ((pie as AnalyticsChartSectorGroupResult).RepeatingEntityIds || []).length,
                    left: 0
                  },
                  animation: false,
                  legend: {
                    type: legend_type,
                    orient: legend_orient,
                    height: legend_height,
                    align: legend_align,
                    width: 'auto',
                    right: 0,
                    top: legend_top,
                    borderWidth: 0,
                    itemWidth: 14,
                    icon: 'roundRect',
                    padding: 0,
                    itemGap: 7,
                    selectorItemGap: 0,
                    selectorButtonGap: 0,
                    textStyle: {
                     // width: Math.floor(this.chart_width*(this.elementWidthMultiplier > 0.5 ? 2*this.elementWidthMultiplier : this.elementWidthMultiplier)*
                       // (100-bars_width)/100),
                      overflow: "break",
                      fontSize: chart_font_size*0.8
                    }
                  },
                  tooltip: {},
                  dataZoom: [
                    {
                      type: 'inside',
                      realtime: true,
                      start: 0,
                      end: 100,
                      filterMode: 'none'
                    }
                  ],
                  textStyle: {
                    fontSize: chart_font_size*0.8,
                    overflow: 'break'
                  },
                  series: {
                    name: '',
                    data: (pie.Descriptor === 2 || pie.Descriptor === 5) ? (pie as AnalyticsChartSectorGroupResult).SectorResults?.map(el => {
                      const split_ident = ''+(el.Id.SplittingType === ChartUniqueSplitType.Parameter ? el.Id.ParameterId+':'+el.Id.EntityId : el.Id.EntityId)+'-'+el.Id.SplittingType;
                      return {
                        name: /*trimEllip(el.Name, 20)*/el.Name+' '+el.Value, value: el.Value,
                        itemStyle: {
                          color: el.Id.EntityId != 0 ? this.colors.get(split_ident) : gen().hexString()
                        }
                      }
                    }) : (pie as AnalyticsChartElementWithFormulasResult).FormulaResults?.map(el => {
                      const split_ident = el.Id;
                      return {
                        name: /*trimEllip(el.Name, 20)*/el.Name+' '+el.Value, value: (el.Value || 10) >= 0 ? el.Value : 0,
                        itemStyle: {
                          color: el.Value != null ? (el.Id != 0 ? this.colors.get(split_ident) : gen().hexString()) : 'grey'
                        }
                      }
                    }),
                    type: 'pie',
                    radius: [chart_r1, chart_r2],
                    center: [chart_x, chart_y],
                    label: {
                      show: true,
                      // rotate: true,
                     // position: 'inside'
                    },
                    minShowLabelAngle: 1,
                    avoidLabelOverlap: true,
                        emphasis: {
                          itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                        }
                    }
                  }
              })
            } else if (this.theModel.ChartType === AnalyticsV2ChartType.Bar) {

              // generate random colors
              // const colors = new Map();
              this.data_volume_size = new Map();
              // this.longest_line = new Map();
              this.isWorkload = false;
            
              (this.theModel as AnalyticsBarChartBundleResult).BarChartResults.forEach((bar, bar_index) => {
                this.data_volume_size.set(bar_index, (bar as AnalyticsChartSectorGroupResult).SectorResults ? 
                (bar as AnalyticsChartSectorGroupResult).SectorResults.length : 0);
                // this.longest_line.set(bar_index, 0);

                (bar as AnalyticsChartSectorGroupResult).SectorResults?.forEach(el => {
                  // if (this.longest_line.get(bar_index) || 0 < el.Name.length) {
                  //   this.longest_line.set(bar_index, el.Name.length);
                  // }

                  if (bar.Descriptor === 5) {
                    this.isWorkload = true;
                  }

                  const split_ident = (bar.Descriptor === 2 || bar.Descriptor === 5) ? 
                  ''+(el.Id.SplittingType === ChartUniqueSplitType.Parameter ? el.Id.ParameterId+':'+el.Id.EntityId : el.Id.EntityId)+'-'+el.Id.SplittingType
                  : el.Id;
                  // if (el.Id.EntityId != 0 && !this.colors.get(split_ident)) {
                  //   const new_color = gen().hexString();
                  //   this.colors.set(split_ident, new_color)
                  // }
                  if (((bar.Descriptor === 2 || bar.Descriptor === 5) ? el.Id.EntityId : el.Id) != 0 && !this.colors.get(split_ident)) {
                    const new_color = gen().hexString();
                    this.colors.set(split_ident, new_color)
                  }
                })
              });

              this.option = (this.theModel as AnalyticsBarChartBundleResult).BarChartResults.map((bar, bar_index) => {

                let legend_type = 'scroll'
                let legend_orient = 'vertical'
                let bars_width = Math.round(this.base_bar_chart_width*this.elementWidthMultiplier/(this.base_bar_chart_width + this.base_bar_chart_height)*100)+'%';
                this.chart_width = this.base_bar_chart_width + this.base_bar_chart_height
                this.chart_height = this.base_bar_chart_height
                let legend_width = this.chart_height
                let legend_align = 'right'
                let chart_font_size = 10;

                let bars_mult = this.elementWidthMultiplier < 1 ? Math.pow(this.elementWidthMultiplier*2, 0.7) : Math.pow(this.elementWidthMultiplier*2, 0.3)

                // any lines, very large data
                legend_type = 'scroll'

                const real_koeff = Math.pow(this.elementWidthMultiplier, 0.3)
                this.chart_multiplier = 1.4;
                this.chart_height = this.base_bar_chart_height*(this.chart_multiplier/real_koeff)

                bars_width = Math.round((this.base_bar_chart_width*bars_mult/(this.base_bar_chart_width + this.base_bar_chart_height))*100)+'%';
                this.chart_width = this.base_bar_chart_width*this.chart_multiplier + this.base_bar_chart_height
                legend_width = this.chart_height

                chart_font_size = chart_font_size*real_koeff

                return {
                  // custom
                  repeating: (bar as AnalyticsChartSectorGroupResult).RepeatingEntityIds || [],
                  // standard
                  title: {
                    // standard
                    text: '',
                    subtext: '',
                    // custom
                    custom_text: (bar as AnalyticsChartSectorGroupResult).Name,
                    custom_subtext: this.getSectorCalculateStatusName((bar as AnalyticsChartSectorGroupResult).CalculateStatus) + 
                    ((bar as AnalyticsChartSectorGroupResult).CalculateStatus  != null && (bar as AnalyticsChartSectorGroupResult).CalculateStatus != AnalyticsChartSectorCalculateStatus.Ok ? ', ' : '') +
                    str+' ' + ((bar as AnalyticsChartSectorGroupResult).RepeatingEntityIds || []).length,
                    left: 0
                  },
                  grid: {
                    containLabel: true,
                    width: bars_width,
                    height: '80%',
                    top: 20,
                    left: 0,
                  },
                  legend: {
                    type: legend_type,
                    orient: legend_orient,
                    align: legend_align,
                    height: '90%',
                    right: 0,
                    top: 0,
                    width: legend_width,
                    borderWidth: 0,
                    borderRadius: 1,
                    itemWidth: 14,
                    icon: 'roundRect',
                    padding: 0,
                    itemGap: 7,
                    textStyle: {
                      fontSize: chart_font_size,
                      padding: 0,
                      width: 130, // set to grid right - item width (default 25) - 5 set tooltip right to grid right
                      overflow: "break",
                    }
                  },
                  textStyle: {
                    fontSize: chart_font_size*((this.data_volume_size.get(bar_index) || 1) > 20 ? 0.8 : 1),
                  },
                  animation: false,
                  xAxis: {
                    data: [(bar as AnalyticsChartSectorGroupResult).Name],
                    axisLabel: {
                      show: false
                    },
                    axisTick: {
                      show: false
                    },
                    axisLine: {
                      show: false
                    },
                    maxInterval: 1,
                    z: 10,
                  },
                  yAxis: {
                    axisLine: {
                      show: false
                    },
                    axisTick: {
                      show: false
                    },
                    axisLabel: {
                      color: '#999'
                    }
                  },
                  width: '100%',
                  tooltip: {},
                  series: (bar.Descriptor === 2 || bar.Descriptor === 5) ? (bar as AnalyticsChartSectorGroupResult).SectorResults?.map((el: any) => {
                    const split_ident = ''+(el.Id.SplittingType === ChartUniqueSplitType.Parameter ? el.Id.ParameterId+':'+el.Id.EntityId : el.Id.EntityId)+'-'+el.Id.SplittingType;
                    return {
                      name: /*trimEllip(el.Name, 20)*/ el.Name+'   '+el.Value,
                      data: [el.Value],
                      type: 'bar',
                      barCategoryGap: 5,
                      // barMaxWidth: 10,
                      barGap: 0.5,
                      itemStyle: {
                        color: el.Id.EntityId != 0 ? this.colors.get(split_ident) : gen().hexString()
                      },
                      label: {
                        show: true,
                        position: 'insideBottom',
                        distance: '15',
                        align: 'left',
                        rotate: '90',
                        verticalAlign: 'middle',
                        formatter: '{name|{a}}',
                        fontSize: chart_font_size,
                        rich: {
                          name: {}
                        }
                      },
                      showBackground: true
                    }
                  }) : (bar as AnalyticsChartElementWithFormulasResult).FormulaResults?.map((el: any) => {
                    const split_ident = el.Id;
                    return {
                      name: /*trimEllip(el.Name, 20)*/ el.Name+'   '+Math.round((el.Value + Number.EPSILON) * 100) / 100,
                      data: [Math.round((el.Value + Number.EPSILON) * 100) / 100 || 0],
                      type: 'bar',
                      barCategoryGap: 5,
                      // barMaxWidth: 10,
                      barGap: 0.5,
                      itemStyle: {
                        color: el.Value != null ? (el.Id != 0 ? this.colors.get(split_ident) : gen().hexString()) : 'grey'
                      },
                      label: {
                        show: true,
                        position: 'insideBottom',
                        distance: '15',
                        align: 'left',
                        rotate: '90',
                        verticalAlign: 'middle',
                        formatter: '{name|{a}}',
                        fontSize: chart_font_size,
                        rich: {
                          name: {}
                        }
                      },
                      showBackground: true
                    }
                  })
                }
              });
              
              // console.log(this.option)
            }
        }, 500);
      });
    }

    async onRepeatingClick(event: any, opt_index: number, rep_ids: number[]) {
      this.entity_ids = rep_ids;

      if (event.componentSubType === 'pie') {
        this.sectorName = ((this.theModel as AnalyticsPieChartBundleResult)
          .PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.dataIndex].Name + 
          ` (${this.$t('repeating')})`;
      } else if (event.componentSubType === 'bar') {
        this.sectorName = ((this.theModel as AnalyticsBarChartBundleResult)
          .BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.componentIndex].Name + 
          ` (${this.$t('repeating')})`;
      }
      if (!this.srcElement) { return }

      await this.chartElementShow();
    }

    saveChartToFile() {
      if (!this.$refs.chart) { return }

      // @ts-ignore
      // console.log(this.$refs.chart[0])

      // @ts-ignore
      const imageElement = this.$refs.chart[0].getDataURL({
          pixelRatio: 3,
          backgroundColor: '#fff'
      });

      const saveImage = (downloadUrl: string) => {
          const downloadImage = document.createElement("a");
          document.body.appendChild(downloadImage);
          downloadImage.setAttribute("download", "image");
          downloadImage.href = downloadUrl;
          downloadImage.click();
          downloadImage.remove();
      };

      saveImage(imageElement)
    }

    async onChartClick(event: any, opt_index: number) {
      if (event.componentSubType === 'line') {

        console.log((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex])

        // Curves
        if ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex].Descriptor === 1 ||
        (this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex].Descriptor === 4) {
          // if ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex].Descriptor === 4) {
            this.linear_params = {
              CurveId: ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsWorkloadLinearChartCurveResult).CurveId,
              StartDate: new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[event.dataIndex].StartDate),
              EndDate: new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[event.dataIndex].EndDate)
            }
          // }
          this.entity_ids = ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsLinearChartCurveResult).PointResults[event.dataIndex].EntityIds;
          this.sectorName = ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsLinearChartCurveResult).Name + ': ' +
            (new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[event.dataIndex].StartDate).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' }) + ' - ' + 
            (new Date((this.theModel as AnalyticsLinearChartResult).XAxisValues[event.dataIndex].EndDate).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })));
          
          /* console.time('concat_mock');
          this.entity_ids = ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsLinearChartCurveResult).PointResults[0].EntityIds;
          
          for (let point = 1; point < event.dataIndex; point++) {
            if (point % 100 === 0 || point == event.dataIndex-1) {
              for (let a = (point*100)+1; a < (point*100); a++) {
                this.entity_ids.push(...((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsLinearChartCurveResult).PointResults[a].EntityIds.slice(0, 100));
              }
            }
          }
          console.timeEnd('concat_mock'); */

          await this.chartElementShow();
        } else 
        // Formulas
        if ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex].Descriptor === 3) {
          const fRes = ((this.theModel as AnalyticsLinearChartResult).CurveResults[event.componentIndex] as AnalyticsChartElementWithFormulasResult).FormulaResults[event.dataIndex];
          // console.log(fRes)
          if (fRes.Value == null || fRes.Value == undefined || fRes.ErrorResult) {
            // error values
            const errRes = fRes.ErrorResult
            if (errRes != undefined && errRes != null) {
              this.currentTokens = reactive(errRes.Tokens.map((el: ChartElementFormulaTokenError) => el.Token));
              this.sectorName = errRes.Type === ChartElementFormulaErrorResultType.TokenErrors ? this.$t('formula_not_found_or_not_calculated') : this.$t('incorrect_calc_result');
            } else {
              this.currentTokens = reactive([])
              this.sectorName = this.$t('incorrect_calc_result');
            }
          } else {
            this.currentTokens = reactive(fRes.Representation.Tokens);
            this.sectorName = fRes.Name + ' - '+this.$t('formula_values');
          }
          // do not load table
          this.showSectorTable = false;
          return;
        }
      } else if (event.componentSubType === 'pie') {
        if (((this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 2 ||
        ((this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 5) {
          
          // if (((this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 5) {
            const pie = (this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsWorkloadChartSectorGroupResult;
            this.currentChartId = pie.ChartId;
            this.worker_ids = (pie.SectorResults[event.dataIndex] as AnalyticsWorkloadChartSectorResult).SplitWorkerIds;
          // }
          
          this.entity_ids = ((this.theModel as AnalyticsPieChartBundleResult)
            .PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.dataIndex].EntityIds;
          this.sectorName = ((this.theModel as AnalyticsPieChartBundleResult)
            .PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.dataIndex].Name;
          
          await this.chartElementShow();
        } else 
        // Formulas
        if (((this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 3) {
          const fRes = (((this.theModel as AnalyticsPieChartBundleResult).PieChartResults[opt_index] as AnalyticsChartElementWithFormulasResult) as AnalyticsChartElementWithFormulasResult).FormulaResults[event.dataIndex];
          // console.log(fRes)
          if (fRes.Value == null || fRes.Value == undefined || fRes.ErrorResult) {
            // error values
            const errRes = fRes.ErrorResult
            if (errRes != undefined && errRes != null) {
              this.currentTokens = reactive(errRes.Tokens.map((el: ChartElementFormulaTokenError) => el.Token));
              this.sectorName = errRes.Type === ChartElementFormulaErrorResultType.TokenErrors ? this.$t('formula_not_found_or_not_calculated') : this.$t('incorrect_calc_result');
            } else {
              this.currentTokens = reactive([])
              this.sectorName = this.$t('incorrect_calc_result');
            }
          } else {
            this.currentTokens = reactive(fRes.Representation.Tokens);
            this.sectorName = fRes.Name + ' - '+this.$t('formula_values');
          }
          // do not load table
          this.showSectorTable = false;
          return;
        }
      } else if (event.componentSubType === 'bar') {
        if (((this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 2 ||
          ((this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 5) {

          // if (((this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 5) {
            const bar = (this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsWorkloadChartSectorGroupResult;
            this.currentChartId = bar.ChartId;
            this.worker_ids = (bar.SectorResults[event.componentIndex] as AnalyticsWorkloadChartSectorResult).SplitWorkerIds;
          // }

          this.entity_ids = ((this.theModel as AnalyticsBarChartBundleResult)
            .BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.componentIndex].EntityIds;
          this.sectorName = ((this.theModel as AnalyticsBarChartBundleResult)
            .BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).SectorResults[event.componentIndex].Name;

          await this.chartElementShow();
        } else // Formulas
        if (((this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsChartSectorGroupResult).Descriptor === 3) {
          const fRes = (((this.theModel as AnalyticsBarChartBundleResult).BarChartResults[opt_index] as AnalyticsChartElementWithFormulasResult) as AnalyticsChartElementWithFormulasResult).FormulaResults[event.componentIndex];
          // console.log(fRes)
          if (fRes.Value == null || fRes.Value == undefined || fRes.ErrorResult) {
            // error values
            const errRes = fRes.ErrorResult
            if (errRes != undefined && errRes != null) {
              this.currentTokens = reactive(errRes.Tokens.map((el: ChartElementFormulaTokenError) => el.Token));
              this.sectorName = errRes.Type === ChartElementFormulaErrorResultType.TokenErrors ? this.$t('formula_not_found_or_not_calculated') : this.$t('incorrect_calc_result');
            } else {
              this.currentTokens = reactive([])
              this.sectorName = this.$t('incorrect_calc_result');
            }
          } else {
            this.currentTokens = reactive(fRes.Representation.Tokens);
            this.sectorName = fRes.Name + ' - '+this.$t('formula_values');
          }
          // do not load table
          this.showSectorTable = false;
          return;
        }
      }
      if (!this.srcElement) { return }
    }

    async chartElementShow() {
      this.sectorTableModel = reactive({} as AnalyticsResultTableExtended);
      this.showSectorTable = true;
      this.currentTokens = reactive([])

      this.resetPagination();

      if (localStorage.rowcount) {
        const countObjectStored = JSON.parse(localStorage.rowcount)
        const countStored = countObjectStored['tbl_'+this.genstore.selectedItem.Id+'_'+this.genstore.selectedItem.DestType+'_'+this.genstore.selectedItem.SrcType]
        
        if (countStored) {
          this.pagination.count = countStored
          this.auxstore.setTableRowCount(countStored)
        } else {
          this.pagination.count = Number(this.auxstore.getDefaultRowCount)
          this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount)
        }
      } else {
        this.pagination.count = Number(this.auxstore.getDefaultRowCount)
        this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount)
      }
      // request itself
      let t_result: any = reactive({});

      if (!this.isWorkload) {
        if (!this.entity_ids?.length) {
          this.pagination.total_count = 0;
          this.sectorTableModel = reactive({} as AnalyticsResultTableExtended);
          return;
        }
        const request = {
          ChartIdentity: this.srcElement,
          EntityIds: this.entity_ids,
          ChartElementId: this.theModel.ChartType === AnalyticsV2ChartType.Linear ? (this.linear_params?.CurveId || 0) : this.currentChartId,
          Offset: 0,
          Count: Number(this.auxstore.getTableRowCount),
          Ordering: null
        } as AnalyticsChartSectorTableAsker;

        t_result = await this.auxstore.getChartSectorTable(request, this.pagination)
      } else {
        const request: AnalyticsWorkloadChartTableAskerBase = {
          Offset: 0,
          Count: Number(this.auxstore.getTableRowCount),
          Ordering: null
        };

        switch (this.theModel.ChartType) {
          case AnalyticsV2ChartType.Linear:
            (request as AnalyticsWorkloadCurvePointTableAsker).CurveId = this.linear_params?.CurveId || 0;
            (request as AnalyticsWorkloadCurvePointTableAsker).StartDate = this.linear_params?.StartDate || new Date();
            (request as AnalyticsWorkloadCurvePointTableAsker).EndDate = this.linear_params?.EndDate || new Date();
            break;
          case AnalyticsV2ChartType.Pie:
          case AnalyticsV2ChartType.Bar:
            (request as AnalyticsWorkloadChartSectorTableAsker).ChartId = this.currentChartId;
            (request as AnalyticsWorkloadChartSectorTableAsker).WorkerIds = this.worker_ids;
            break;
          default:
            break;
        }

        t_result = await this.auxstore.getWorkLoadChartSectorTable(request, this.pagination, this.theModel.ChartType)
      }

      // console.log(this.pagination)
      this.pagination.total_count = +(t_result.data ? t_result.data.Count : 0);
      this.sectorTableModel = reactive((t_result.data || {}) as AnalyticsResultTableExtended);
    }

    async onMovePage(pag: PaginationProps) {
      // Модель НЕ обнуляем до ответа: старые данные (шапка + строки) остаются
      // видимыми, тело притухает, а под шапкой идёт refresh-strip. Так же, как в
      // главной таблице. Обнуляем только когда выбора нет (пустое состояние).
      let t_result: any = reactive({});

      if (!this.isWorkload) {
        if (!this.entity_ids?.length) {
          this.sectorTableModel = reactive({} as AnalyticsResultTableExtended);
          return;
        }
        const request: any = {
          ChartIdentity: this.srcElement,
          EntityIds: this.entity_ids,
          ChartElementId: this.theModel.ChartType === AnalyticsV2ChartType.Linear ? (this.linear_params?.CurveId || 0) : this.currentChartId,
          Offset: pag.offset,
          Count: Number(this.auxstore.getTableRowCount),
          Ordering: null
        } as AnalyticsChartSectorTableAsker

        // Сортировка есть только при OrderMode 2/3. На третий клик OrderMode=1 (сброс) —
        // это отсутствие сортировки, поэтому Ordering целиком оставляем null, а не шлём
        // объект с ColumnCategory=null.
        if (pag.sortMode > 1) {
          request.Ordering = {
            ColumnCategory: pag.sortCategory,
            OrderMode: pag.sortMode,
            OrderingEntityIds: Array.isArray(pag.OrderingEntityIds)
              ? pag.OrderingEntityIds
              : []
          } as AnalyticsChartSectorTableOrdering;
        }

        t_result = await this.auxstore.getChartSectorTable(request, pag)
      } else {
        const request: AnalyticsWorkloadChartTableAskerBase = {
          Offset: pag.offset,
          Count: Number(this.auxstore.getTableRowCount),
          Ordering: null
        };

        // На третий клик (сброс) OrderMode=1 — сортировки нет, Ordering оставляем null.
        if (pag.sortMode > 1) {
          request.Ordering = {
            ColumnCategory: pag.sortCategory,
            OrderMode: pag.sortMode,
            OrderingEntityIds: Array.isArray(pag.OrderingEntityIds)
              ? pag.OrderingEntityIds
              : []
          } as AnalyticsChartSectorTableOrdering;
        }

        switch (this.theModel.ChartType) {
          case AnalyticsV2ChartType.Linear:
            (request as AnalyticsWorkloadCurvePointTableAsker).CurveId = this.linear_params?.CurveId || 0;
            (request as AnalyticsWorkloadCurvePointTableAsker).StartDate = this.linear_params?.StartDate || new Date();
            (request as AnalyticsWorkloadCurvePointTableAsker).EndDate = this.linear_params?.EndDate || new Date();
            break;
          case AnalyticsV2ChartType.Pie:
          case AnalyticsV2ChartType.Bar:
            (request as AnalyticsWorkloadChartSectorTableAsker).ChartId = this.currentChartId;
            (request as AnalyticsWorkloadChartSectorTableAsker).WorkerIds = this.worker_ids;
            break;
          default:
            break;
        }

        t_result = await this.auxstore.getWorkLoadChartSectorTable(request, this.pagination, this.theModel.ChartType)
      }
      this.sectorTableModel = reactive((t_result.data || {}) as AnalyticsResultTableExtended);
    }

    async onRefreshPage(pag: PaginationProps) {
      // Модель НЕ обнуляем до ответа (см. onMovePage): при сортировке/обновлении
      // шапка остаётся, тело притухает, снизу refresh-strip. Обнуляем только при
      // отсутствии выбора - тогда таблица пустая.
      if (!this.isWorkload && !this.entity_ids?.length) {
        this.sectorTableModel = reactive({} as AnalyticsResultTableExtended);
        return;
      }
      
      // sortMode 2/3 — реальная сортировка; 0/1 (в т.ч. сброс на третий клик) — её нет,
      // тогда идём в ветку с Ordering=null, а не строим Ordering с ColumnCategory=null.
      if (!pag.sortMode || pag.sortMode <= 1) {
        const that = this
        setTimeout(async () => {
          // request itself
          let t_result: any = reactive({});
          if (!this.isWorkload) {
            const request = {
              ChartIdentity: this.srcElement,
              EntityIds: this.entity_ids,
              Offset: pag.offset,
              ChartElementId: this.theModel.ChartType === AnalyticsV2ChartType.Linear ? (this.linear_params?.CurveId || 0) : this.currentChartId,
              Count: Number(this.auxstore.getTableRowCount),
              Ordering: null
            }as AnalyticsChartSectorTableAsker
            t_result = await that.auxstore.getChartSectorTable(request, pag)
          } else {
            const request: AnalyticsWorkloadChartTableAskerBase = {
              Offset: pag.offset,
              Count: Number(this.auxstore.getTableRowCount),
              Ordering: null
            };
            switch (this.theModel.ChartType) {
              case AnalyticsV2ChartType.Linear:
                (request as AnalyticsWorkloadCurvePointTableAsker).CurveId = this.linear_params?.CurveId || 0;
                (request as AnalyticsWorkloadCurvePointTableAsker).StartDate = this.linear_params?.StartDate || new Date();
                (request as AnalyticsWorkloadCurvePointTableAsker).EndDate = this.linear_params?.EndDate || new Date();
                break;
              case AnalyticsV2ChartType.Pie:
              case AnalyticsV2ChartType.Bar:
                (request as AnalyticsWorkloadChartSectorTableAsker).ChartId = this.currentChartId;
                (request as AnalyticsWorkloadChartSectorTableAsker).WorkerIds = this.worker_ids;
                break;
              default:
                break;
            }
            t_result = await this.auxstore.getWorkLoadChartSectorTable(request, this.pagination, this.theModel.ChartType)
          }
          this.sectorTableModel = reactive((t_result.data || {}) as AnalyticsResultTableExtended);
        }, 500)
      } else {
        const that = this
        setTimeout(async () => {
          // request itself
          let t_result: any = reactive({});
          if (!this.isWorkload) {
            const request = {
              ChartIdentity: this.srcElement,
              EntityIds: this.entity_ids,
              Offset: pag.offset,
              ChartElementId: this.theModel.ChartType === AnalyticsV2ChartType.Linear ? (this.linear_params?.CurveId || 0) : this.currentChartId,
              Count: Number(this.auxstore.getTableRowCount),
              Ordering: {
                ColumnCategory: pag.sortCategory,
                OrderMode: pag.sortMode,
                OrderingEntityIds: Array.isArray(pag.OrderingEntityIds)
                  ? pag.OrderingEntityIds
                  : []
              } as AnalyticsChartSectorTableOrdering
            } as AnalyticsChartSectorTableAsker;
            t_result = await that.auxstore.getChartSectorTable(request, pag)
          } else {
            const request: AnalyticsWorkloadChartTableAskerBase = {
              Offset: pag.offset,
              Count: Number(this.auxstore.getTableRowCount),
              Ordering: {
                ColumnCategory: pag.sortCategory,
                OrderMode: pag.sortMode,
                OrderingEntityIds: Array.isArray(pag.OrderingEntityIds)
                  ? pag.OrderingEntityIds
                  : []
              } as AnalyticsChartSectorTableOrdering
            };

            switch (this.theModel.ChartType) {
              case AnalyticsV2ChartType.Linear:
                (request as AnalyticsWorkloadCurvePointTableAsker).CurveId = this.linear_params?.CurveId || 0;
                (request as AnalyticsWorkloadCurvePointTableAsker).StartDate = this.linear_params?.StartDate || new Date();
                (request as AnalyticsWorkloadCurvePointTableAsker).EndDate = this.linear_params?.EndDate || new Date();
                break;
              case AnalyticsV2ChartType.Pie:
              case AnalyticsV2ChartType.Bar:
                (request as AnalyticsWorkloadChartSectorTableAsker).ChartId = this.currentChartId;
                (request as AnalyticsWorkloadChartSectorTableAsker).WorkerIds = this.worker_ids;
                break;
              default:
                break;
            }

            t_result = await this.auxstore.getWorkLoadChartSectorTable(request, this.pagination, this.theModel.ChartType)
          }
          this.sectorTableModel = reactive((t_result.data || {}) as AnalyticsResultTableExtended);
        }, 500)
      }
    }

    get theModel() {
      return this.modelValue
    }

    set theModel(arg: any) {
      this.emitModelValue = arg
    }
  }
</script>

<style lang="scss">
/* Кнопки панели графика: обычные кнопки с inline-svg (currentColor), как в
   сплиттере средней панели (toolbar-icon-btn). Без рамки/фона, цвет через
   currentColor: покой #979797, наведение #3F884F, disabled #d2d2d2. */
.qt-panel-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* Без внутреннего горизонтального padding: ширину/зазор задаём только боковыми
     margin, иначе padding + margin вместе дают лишний отступ у иконок. */
  padding: 0;
  height: 40px;
  /* Опускаем иконки на 3px под остальные элементы панели. На кнопках НЕ ставить
     Quasar-утилиты q-my-* (они с !important и перебьют этот margin-top). */
  margin-top: 3px;
  /* По 5px по бокам: между соседними иконками отступы складываются в 10px. */
  margin-left: 5px;
  margin-right: 5px;
  border: none;
  background: none;
  cursor: pointer;
  color: #979797;
}

.qt-panel-icon-btn:not(:disabled):hover {
  color: #3f884f;
}

.qt-panel-icon-btn:disabled {
  color: #d2d2d2;
  cursor: default;
}
</style>